import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import { getPasswordResetLink } from '@adornis/users/server/password.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { sendPasswordResetEmail } from '../../server/utils/email.js';

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const requestPasswordResetMutation = registerMutation({
  operationName: 'requestPasswordResetMutation',
  type: () => Boolean,
  params: [{ name: 'email', type: () => String }],
  resolve: (email: string) => async () => {
    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) return true;

    const userCollection = await getRawCollection(AdornisUser._collectionName);
    const user = await userCollection.findOne({
      email: { $regex: new RegExp(`^${escapeRegExp(normalizedEmail)}$`, 'i') },
    });

    // Intentionally return success for unknown emails to prevent account enumeration.
    if (!user) return true;

    const frontendResetPath = new URL('/auth/reset-password', baseConfig.get('ROOT_URL')).toString();
    const userID = String(user._id);
    const userClass = typeof user._class === 'string' ? user._class : AdornisUser._class;

    const resetLink = await getPasswordResetLink(frontendResetPath, {
      userID,
      userClass,
      ttu: 1,
    });

    await sendPasswordResetEmail(normalizedEmail, resetLink);
    return true;
  },
});
